// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { cashoutEnhance } from '../../actions/cashout';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';

import HistoryItemCashoutButtons from './HistoryItemCashoutButtons';
import selectHistoryItemCashoutButtonsProps from './HistoryItemCashoutButtons.selector';

type HistoryItemCashOutButtonsContainerProps = {
  id: number;
  completeBetAllowed: boolean;
  cashoutAllowed: boolean;
  cashoutValue: number;
  cashoutStatus: boolean | null | undefined;
};

const HistoryItemCashOutButtonsContainer = (ownProps: HistoryItemCashOutButtonsContainerProps) => {
  const { id, completeBetAllowed, cashoutAllowed, cashoutValue } = ownProps;

  const selectorProps = useMemo(
    () => ({ id, completeBetAllowed, cashoutAllowed, cashoutValue }),
    [id, completeBetAllowed, cashoutAllowed, cashoutValue],
  );

  const selectedProps = useSelector((state) => selectHistoryItemCashoutButtonsProps(state, selectorProps));

  const actions = useMemo(() => ({ cashoutEnhance }), []);

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, actionsProps, selectedProps });

  return <HistoryItemCashoutButtons {...enhancedProps} />;
};

export default HistoryItemCashOutButtonsContainer;
